// (c) Copyright Ascensio System SIA 2009-2025
//
// This program is a free software product.
// You can redistribute it and/or modify it under the terms
// of the GNU Affero General Public License (AGPL) version 3 as published by the Free Software
// Foundation. In accordance with Section 7(a) of the GNU AGPL its Section 15 shall be amended
// to the effect that Ascensio System SIA expressly excludes the warranty of non-infringement of
// any third-party rights.
//
// This program is distributed WITHOUT ANY WARRANTY, without even the implied warranty
// of MERCHANTABILITY or FITNESS FOR A PARTICULAR  PURPOSE. For details, see
// the GNU AGPL at: http://www.gnu.org/licenses/agpl-3.0.html
//
// You can contact Ascensio System SIA at Lubanas st. 125a-25, Riga, Latvia, EU, LV-1021.
//
// The  interactive user interfaces in modified source and object code versions of the Program must
// display Appropriate Legal Notices, as required under Section 5 of the GNU AGPL version 3.
//
// Pursuant to Section 7(b) of the License you must retain the original Product logo when
// distributing the program. Pursuant to Section 7(e) we decline to grant you any rights under
// trademark law for use of our trademarks.
//
// All the Product's GUI elements, including illustrations and icon sets, as well as technical writing
// content are licensed under the terms of the Creative Commons Attribution-ShareAlike 4.0
// International. See the License terms at http://creativecommons.org/licenses/by-sa/4.0/legalcode

import ArSAReactSvg from "PUBLIC_DIR/images/flags/ar-SA.react.svg";
import AzReactSvg from "PUBLIC_DIR/images/flags/az.react.svg";
import BgReactSvg from "PUBLIC_DIR/images/flags/bg.react.svg";
import CsReactSvg from "PUBLIC_DIR/images/flags/cs.react.svg";
import DeATReactSvg from "PUBLIC_DIR/images/flags/de-AT.react.svg";
import DeCHReactSvg from "PUBLIC_DIR/images/flags/de-CH.react.svg";
import DeReactSvg from "PUBLIC_DIR/images/flags/de.react.svg";
import ElGRReactSvg from "PUBLIC_DIR/images/flags/el-GR.react.svg";
import EnGBReactSvg from "PUBLIC_DIR/images/flags/en-GB.react.svg";
import EnUSReactSvg from "PUBLIC_DIR/images/flags/en-US.react.svg";
import EsMXReactSvg from "PUBLIC_DIR/images/flags/es-MX.react.svg";
import EsReactSvg from "PUBLIC_DIR/images/flags/es.react.svg";
import FiReactSvg from "PUBLIC_DIR/images/flags/fi.react.svg";
import FrReactSvg from "PUBLIC_DIR/images/flags/fr.react.svg";
import HyAMReactSvg from "PUBLIC_DIR/images/flags/hy-AM.react.svg";
import ItReactSvg from "PUBLIC_DIR/images/flags/it.react.svg";
import JaJPReactSvg from "PUBLIC_DIR/images/flags/ja-JP.react.svg";
import KoKRReactSvg from "PUBLIC_DIR/images/flags/ko-KR.react.svg";
import LoLAReactSvg from "PUBLIC_DIR/images/flags/lo-LA.react.svg";
import LvReactSvg from "PUBLIC_DIR/images/flags/lv.react.svg";
import NlReactSvg from "PUBLIC_DIR/images/flags/nl.react.svg";
import PlReactSvg from "PUBLIC_DIR/images/flags/pl.react.svg";
import PtBRReactSvg from "PUBLIC_DIR/images/flags/pt-BR.react.svg";
import PtReactSvg from "PUBLIC_DIR/images/flags/pt.react.svg";
import RoReactSvg from "PUBLIC_DIR/images/flags/ro.react.svg";
import RuReactSvg from "PUBLIC_DIR/images/flags/ru.react.svg";
import SkReactSvg from "PUBLIC_DIR/images/flags/sk.react.svg";
import SlReactSvg from "PUBLIC_DIR/images/flags/sl.react.svg";
import SiReactSvg from "PUBLIC_DIR/images/flags/si.react.svg";
import SrReactSvg from "PUBLIC_DIR/images/flags/sr.react.svg";
import SqALReactSvg from "PUBLIC_DIR/images/flags/sq-AL.react.svg";
import TrReactSvg from "PUBLIC_DIR/images/flags/tr.react.svg";
import UkUAReactSvg from "PUBLIC_DIR/images/flags/uk-UA.react.svg";
import ViReactSvg from "PUBLIC_DIR/images/flags/vi.react.svg";
import ZhCNReactSvg from "PUBLIC_DIR/images/flags/zh-CN.react.svg";

export const flagsIcons = new Map([
  ["ar-SA.react.svg", ArSAReactSvg],
  ["az.react.svg", AzReactSvg],
  ["bg.react.svg", BgReactSvg],
  ["cs.react.svg", CsReactSvg],
  ["de-AT.react.svg", DeATReactSvg],
  ["de-CH.react.svg", DeCHReactSvg],
  ["de.react.svg", DeReactSvg],
  ["el-GR.react.svg", ElGRReactSvg],
  ["en-GB.react.svg", EnGBReactSvg],
  ["en-US.react.svg", EnUSReactSvg],
  ["es-MX.react.svg", EsMXReactSvg],
  ["es.react.svg", EsReactSvg],
  ["fi.react.svg", FiReactSvg],
  ["fr.react.svg", FrReactSvg],
  ["hy-AM.react.svg", HyAMReactSvg],
  ["it.react.svg", ItReactSvg],
  ["ja-JP.react.svg", JaJPReactSvg],
  ["ko-KR.react.svg", KoKRReactSvg],
  ["lo-LA.react.svg", LoLAReactSvg],
  ["lv.react.svg", LvReactSvg],
  ["nl.react.svg", NlReactSvg],
  ["pl.react.svg", PlReactSvg],
  ["pt-BR.react.svg", PtBRReactSvg],
  ["pt.react.svg", PtReactSvg],
  ["ro.react.svg", RoReactSvg],
  ["ru.react.svg", RuReactSvg],
  ["sk.react.svg", SkReactSvg],
  ["sl.react.svg", SlReactSvg],
  ["si.react.svg", SiReactSvg],
  ["sr.react.svg", SrReactSvg], // Assuming 'sr' is used for both Cyrillic and Latin scripts
  ["sq-AL.react.svg", SqALReactSvg],
  ["tr.react.svg", TrReactSvg],
  ["uk-UA.react.svg", UkUAReactSvg],
  ["vi.react.svg", ViReactSvg],
  ["zh-CN.react.svg", ZhCNReactSvg],
]);
